import { gql } from "apollo-boost";

export const CONFIRM_BOOKING = gql`
  mutation consumerConfirmBooking($bookingId: String!,$branchId: String!, $bookingType: String) {
    consumerConfirmBooking(bookingId: $bookingId,branchId: $branchId, bookingType: $bookingType) {
      id
    }
  }
`;
